import script from "./SuperAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperAdmin.vue?vue&type=script&setup=true&lang=js"

import "./SuperAdmin.vue?vue&type=style&index=0&id=4f930c81&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f930c81"]])

export default __exports__